import { c as _c } from "react/compiler-runtime";
import type { BBox } from '@onefootprint/request-types/dashboard';
import { isSideways, type Rotation } from '@/utils/rotation';
import { rotateBbox } from '../../../utils';
type BboxWithId = {
  id: string;
  bbox: BBox;
  pageId?: number;
};
type BoundingBoxOverlayProps = {
  bboxes: BboxWithId[];
  selectedBboxIds: Set<string>;
  onBboxClick: (id: string, pageId?: number) => void;
  documentWidth: number;
  documentHeight: number;
  rotation?: Rotation;
};
const SELECTED_FILL_COLOR = 'rgba(12, 132, 92, 0.3)';
const SELECTED_STROKE_COLOR = 'rgba(12, 132, 92, 0.8)';
const STROKE_WIDTH = 2;

// Check if bbox coordinates are normalized (0-1 range)
// Normalized coordinates have all values <= 1
const isNormalized = (bbox: BBox): boolean => {
  return bbox.x <= 1 && bbox.y <= 1 && bbox.width <= 1 && bbox.height <= 1;
};

// Convert bbox to pixel coordinates if needed
const toPixelCoords = (bbox: BBox, docWidth: number, docHeight: number): BBox => {
  if (isNormalized(bbox)) {
    return {
      x: bbox.x * docWidth,
      y: bbox.y * docHeight,
      width: bbox.width * docWidth,
      height: bbox.height * docHeight
    };
  }
  return bbox;
};
const BoundingBoxOverlay = t0 => {
  const $ = _c(16);
  const {
    bboxes,
    selectedBboxIds,
    onBboxClick,
    documentWidth,
    documentHeight,
    rotation: t1
  } = t0;
  const rotation = t1 === undefined ? 0 : t1;
  if (bboxes.length === 0) {
    return null;
  }
  const viewBoxWidth = isSideways(rotation) ? documentHeight : documentWidth;
  const viewBoxHeight = isSideways(rotation) ? documentWidth : documentHeight;
  const t2 = `0 0 ${viewBoxWidth} ${viewBoxHeight}`;
  let t3;
  if ($[0] !== bboxes || $[1] !== documentHeight || $[2] !== documentWidth || $[3] !== onBboxClick || $[4] !== rotation || $[5] !== selectedBboxIds) {
    let t4;
    if ($[7] !== documentHeight || $[8] !== documentWidth || $[9] !== onBboxClick || $[10] !== rotation || $[11] !== selectedBboxIds) {
      t4 = t5 => {
        const {
          id,
          bbox
        } = t5;
        const isSelected = selectedBboxIds.has(id);
        const pixelBbox = rotateBbox(toPixelCoords(bbox, documentWidth, documentHeight), rotation, documentWidth, documentHeight);
        return <rect key={id} x={pixelBbox.x} y={pixelBbox.y} width={pixelBbox.width} height={pixelBbox.height} fill={isSelected ? SELECTED_FILL_COLOR : "transparent"} stroke={isSelected ? SELECTED_STROKE_COLOR : "transparent"} strokeWidth={STROKE_WIDTH} className="pointer-events-auto cursor-pointer transition-all duration-150" onClick={() => onBboxClick(id)} />;
      };
      $[7] = documentHeight;
      $[8] = documentWidth;
      $[9] = onBboxClick;
      $[10] = rotation;
      $[11] = selectedBboxIds;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    t3 = bboxes.map(t4);
    $[0] = bboxes;
    $[1] = documentHeight;
    $[2] = documentWidth;
    $[3] = onBboxClick;
    $[4] = rotation;
    $[5] = selectedBboxIds;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <svg className="absolute inset-0 w-full h-full pointer-events-none" viewBox={t2} preserveAspectRatio="xMidYMid meet">{t3}</svg>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
export default BoundingBoxOverlay;